import { render, staticRenderFns } from "./CoinDogFooter.vue?vue&type=template&id=e401150c&scoped=true"
import script from "./CoinDogFooter.vue?vue&type=script&lang=js"
export * from "./CoinDogFooter.vue?vue&type=script&lang=js"
import style0 from "./CoinDogFooter.vue?vue&type=style&index=0&id=e401150c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e401150c",
  null
  
)

export default component.exports